import React from 'react';
import { ArrowDown, BookOpen } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useLang } from '../LanguageContext';

const Hero = () => {
  const { t } = useLang();
  const navigate = useNavigate();

  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="top" className="relative overflow-hidden">
      <div className="relative h-screen min-h-[720px] w-full">
        <div
          className="absolute inset-0 bg-cover bg-center scale-105"
          style={{
            backgroundImage:
              'url(https://images.unsplash.com/photo-1598110750624-207050c4f28c?crop=entropy&cs=srgb&fm=jpg&q=85&w=2000)'
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-r from-[#0d1b36]/90 via-[#0d1b36]/60 to-[#0d1b36]/30" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0d1b36]/40 via-transparent to-[#0d1b36]/70" />

        <div className="relative z-10 h-full flex items-center">
          <div className="max-w-6xl mx-auto px-6 w-full">
            <div className="max-w-2xl pt-20">
              <p className="text-[10px] md:text-xs tracking-[0.35em] uppercase text-[#d4a94c] mb-8 fade-up">
                {t.hero.eyebrow}
              </p>
              <h1 className="font-serif text-[#f6ecd9] text-5xl md:text-7xl leading-[1.05] fade-up fade-up-delay-1">
                {t.hero.t1}<br />
                {t.hero.t2} <em className="text-[#d4a94c] italic font-light">{t.hero.heritage}</em>{t.hero.t3}
              </h1>
              <p className="text-[#f6ecd9]/80 text-base md:text-lg mt-8 max-w-xl leading-relaxed fade-up fade-up-delay-2">
                {t.hero.desc}
              </p>
              <div className="flex flex-wrap gap-4 mt-10 fade-up fade-up-delay-3">
                <button
                  onClick={() => navigate('/nos-patisseries')}
                  className="group flex items-center gap-3 px-7 py-3.5 rounded-full bg-[#d4a94c] text-[#0d1b36] text-[11px] tracking-[0.25em] uppercase font-semibold hover:bg-[#e5bc5f] transition-all duration-300 hover:shadow-lg hover:shadow-[#d4a94c]/30"
                >
                  {t.hero.cta1}
                  <ArrowDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" strokeWidth={1.75} />
                </button>
                <button
                  onClick={() => navigate('/nos-pates')}
                  className="group flex items-center gap-3 px-7 py-3.5 rounded-full border border-[#d4a94c] text-[#d4a94c] text-[11px] tracking-[0.25em] uppercase font-medium hover:bg-[#d4a94c] hover:text-[#0d1b36] transition-all duration-300"
                >
                  {t.hero.cta1b}
                  <ArrowDown className="w-4 h-4 group-hover:translate-y-0.5 transition-transform" strokeWidth={1.75} />
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10">
          <div className="w-6 h-10 rounded-full border border-[#f6ecd9]/40 flex items-start justify-center p-1.5">
            <div className="w-1 h-2 bg-[#d4a94c] rounded-full animate-bounce" />
          </div>
        </div>
      </div>

      {/* Marquee */}
      <div className="bg-[#0d1b36] border-y border-[#d4a94c]/20 overflow-hidden py-5">
        <div className="flex gap-16 marquee whitespace-nowrap">
          {[...t.marquee, ...t.marquee, ...t.marquee].map((item, i) => (
            <span key={i} className="flex items-center gap-16 text-[#f6ecd9]/90 text-sm tracking-[0.25em] uppercase font-light">
              {item}
              <span className="w-1.5 h-1.5 rounded-full bg-[#d4a94c]" />
            </span>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Hero;
